import { Controller } from "@hotwired/stimulus"
import { appliesToForm } from "../../src/shared/helpers/form_field_state"

// Follows a checkbox of the form (`data-unless-checked` / `data-if-checked`,
// see `appliesToForm`), e.g. "Inscrire comme étudiant":
// - `hide` (default): shows this element only while it applies (the activation
//   switch, the recap's company rows);
// - `lock`: while it does not apply, unticks and disables its switch
//   (`input[role=switch]`) and shows its `[data-locked-note]`, then gives the
//   switch its state back (the services a student cannot have).
export default class extends Controller {
  static values = { mode: { type: String, default: "hide" } }

  connect () {
    this.form = this.element.closest("form")
    if (!this.form) return

    this.locked = false
    this.refresh = this.refresh.bind(this)
    this.form.addEventListener("change", this.refresh)
    this.refresh()
  }

  disconnect () {
    this.form?.removeEventListener("change", this.refresh)
  }

  refresh () {
    const applies = appliesToForm(this.form, this.element)

    if (this.modeValue === "lock") {
      this.lock(!applies)
    } else {
      this.element.hidden = !applies
    }
  }

  lock (locked) {
    if (locked === this.locked) return

    this.locked = locked
    this.element.toggleAttribute("data-locked", locked)
    this.element.querySelectorAll("[data-locked-note]").forEach((note) => { note.hidden = !locked })
    this.element.querySelectorAll("input[role=switch]").forEach((input) => {
      if (locked) {
        input.dataset.checkedBeforeLock = input.checked
        input.checked = false
      } else if (input.dataset.checkedBeforeLock) {
        input.checked = input.dataset.checkedBeforeLock === "true"
        delete input.dataset.checkedBeforeLock
      }
      input.disabled = locked
      input.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }
}
